(ns fen.api
  "Where the server is, and the one way to ask it something. EDN in, EDN
  out - the same wire Hejmo uses, because the screen is already data and
  there is nothing to translate."
  (:require [fen.auth :as auth]
            [goog.object :as gobj]
            [kc.core :as kc]))

(def dev-spa-port
  "shadow-cljs's own http server (see shadow-cljs.edn). A page loaded from
  it is a page being worked on, and the server it belongs to is the one
  next door."
  "50017")

(def dev-server-port "50018")

(defn base []
  (or (gobj/get js/globalThis "ENTO_API")
      (when (= dev-spa-port (.-port js/location))
        (str (.-protocol js/location) "//" (.-hostname js/location) ":" dev-server-port))
      ""))

(defn- with-key
  "Every call carries this window's key. A request that is refused because
  there is none is not the same as a server that is not there, so the 401 is
  turned into something the caller can tell apart."
  [opts]
  (let [o (or opts #js {})
        hs (js/Object.assign #js {} (or (gobj/get o "headers") #js {})
                             (clj->js (or (auth/headers) {})))]
    (gobj/set o "headers" hs)
    o))

(defn request [path opts]
  (-> (js/fetch (str (base) path) (with-key opts))
      (.then (fn [^js res]
               (cond
                 (.-ok res)            (.text res)
                 (= 401 (.-status res)) (throw (ex-info "unauthorized" {:type :unauthorized}))
                 :else (throw (js/Error. (str "ento server answered " (.-status res)))))))
      (.then kc/read-edn)))

(defn unauthorized? [e]
  (= :unauthorized (:type (ex-data e))))

(defn request-code!
  "Ask the server to send a code to the one address it knows."
  []
  (request "/api/auth/request" #js {:method "POST"}))

(defn verify-code!
  "The code for a key. Stores the key and takes the flag down - the caller
  has to do neither."
  [code]
  (-> (request "/api/auth/verify"
               (clj->js {:method "POST"
                         :headers {"content-type" "application/edn"}
                         :body (kc/->edn {:code code})}))
      (.then (fn [answer]
               (auth/save-token! (:token answer))
               (auth/satisfied! (select-keys answer [:client :name]))
               answer))))

(defn post-screen
  "The view travels with the call. Without an event this is a plain draw."
  [view event]
  (request "/api/screen"
           (clj->js {:method "POST"
                     :headers {"content-type" "application/edn"}
                     :body (kc/->edn (cond-> {:view view} event (assoc :event event)))})))

(defn poll [rev]
  (request (str "/api/screen?rev=" rev) #js {}))
